module.exports = __webpack_public_path__ + "img/sn.ad32532c.png";